export enum OPEN_COMPANY_TYPE {
    DBP_PARTNER = 0, // DBP公司合伙人
    QUALIFIED_PARTNER = 1, //平台资质合伙人
}

export const APP_DEPLOY_ENV_ENUM = {
    SIM: 1,
    PRE: 2,
    PROD: 3
}